module.exports = __webpack_public_path__ + "img/alex_feedback.d94c9715.svg";